// @flow

import React from 'react';
import PdbGalleryComponent from './pdbGallery';
import { joinArrayOrGetValue } from '../../helpers';

type Props = {
  variant: string,
  has_disclaimer: boolean,
  // has_theather: boolean,
  video_src?: ?string,
  video_position?: ?string,
  video_title?: ?string,
};

const PdbGallery = ({
  variant,
  has_disclaimer,
  video_src,
  video_position,
  video_title,
}: Props) => (
  <PdbGalleryComponent
    boxed={variant !== 'default'}
    showDisclaimer={has_disclaimer}
    videoSrc={video_src}
    videoPosition={video_position && joinArrayOrGetValue(video_position)}
    videoTitle={video_title}
  />
);

PdbGallery.defaultProps = {
  video_src: null,
  video_position: 'second',
  video_title: '',
};

export default PdbGallery;
